import { useQueryAllVessels } from '@/api/queries/vessels';

import useDashboardStore from '@/store/dashboard';
import useVesselsStore from '@/store/vessels';
import { ReactNode, useEffect } from 'react';
import toast from 'react-hot-toast';
import DesktopNav from '@/components/layouts/navigation/DesktopNav';
import MobileNav from '@/components/layouts/navigation/MobileNav';
import HorizontalTabs from './HorizontalTabs';
import { usePathname } from 'next/navigation';

type Props = {
  children: ReactNode;
};

export default function DashboardLayout({ children }: Props) {
  const vesselStore = useVesselsStore((state) => state);
  const { setVessels } = vesselStore;

  // Dashboard uses a fixed sidebar layout now

  // Fetch all vessels
  const { isError, data } = useQueryAllVessels();

  useEffect(() => {
    if (data) setVessels(data);
    if (isError)
      toast.error(
        'Terjadi kesalahan pada pengambilan data kapal, harap hubungi Administrator'
      );
  }, [data, isError, setVessels]);

  const pathname = usePathname();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="hidden lg:flex">
        <DesktopNav />
      </div>

      <div className="pl-0 lg:pl-[72px] flex flex-col min-h-screen transition-all duration-300">
        <main className="flex-1 w-full max-w-[1920px] mx-auto">
          {pathname !== '/grid-maps' && <HorizontalTabs />}
          <div className="p-4 md:p-6 lg:p-8">
            {children}
          </div>
        </main>
      </div>
      <div className="lg:hidden">
        <MobileNav />
      </div>
    </div>
  );
}
